import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/balanced.css';

const Login = () => {
  const location = useLocation();
  const prefillEmail = new URLSearchParams(location.search).get('email') || '';
  const [email, setEmail] = useState(prefillEmail);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await signIn(email, password);
      navigate('/dashboard');
    } catch (err) {
      // Handle specific Supabase errors
      const errorMessage = err.message || '';
      if (errorMessage.includes('body stream already read')) {
        // This happens when Supabase returns an error but the response body was already consumed
        setError('Invalid email or password. Please check your credentials and try again.');
      } else if (errorMessage.includes('Email not confirmed')) {
        setError('Please confirm your email address before signing in. Check your inbox for the confirmation link.');
      } else if (errorMessage.includes('Invalid login credentials')) {
        setError('Invalid email or password. Please check your credentials and try again.');
      } else {
        setError(err.message || 'Failed to sign in. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--light-gray)' }}>
      <div style={{ width: '100%', maxWidth: '400px', padding: '2rem' }}>
        <div className="card-emphasis">
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <img 
              src="/fNew_logo_2.png" 
              alt="IDNTY Logo" 
              style={{ height: '70px', width: 'auto', marginBottom: '0.5rem' }}
            />
            <p style={{ color: 'var(--gray)' }}>Sign in to your account</p>
          </div>

          {prefillEmail && (
            <div style={{ background: '#fef3c7', border: '1px solid #f59e0b', color: '#92400e', padding: '0.75rem', borderRadius: '0.5rem', marginBottom: '1rem', fontSize: '0.875rem' }} data-testid="login-prefill-notice">
              This email is already registered. Enter your password to sign in, or use <Link to="/forgot-password" style={{ color: '#92400e', fontWeight: 600 }}>Forgot password?</Link> if needed.
            </div>
          )}

          {error && (
            <div style={{ background: '#fee2e2', color: '#991b1b', padding: '0.75rem', borderRadius: '0.5rem', marginBottom: '1rem', fontSize: '0.875rem' }} data-testid="login-error">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} data-testid="login-form">
            <div style={{ marginBottom: '1.5rem' }}>
              <label className="form-label">Email Address</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="form-input"
                placeholder="you@company.com"
                data-testid="email-input"
              />
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.375rem' }}>
                <label className="form-label" style={{ marginBottom: 0 }}>Password</label>
                <Link
                  to="/forgot-password"
                  style={{ fontSize: '0.8rem', color: 'var(--gold)', fontWeight: 600, textDecoration: 'none' }}
                  data-testid="forgot-password-link"
                >
                  Forgot password?
                </Link>
              </div>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="form-input"
                placeholder="••••••••"
                data-testid="password-input"
              />
            </div>

            <div style={{ marginBottom: '1.5rem' }} />

            <button
              type="submit"
              disabled={loading}
              className="btn btn-primary"
              style={{ width: '100%', marginBottom: '1rem' }}
              data-testid="login-submit-btn"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>

            <p style={{ textAlign: 'center', fontSize: '0.875rem', color: 'var(--gray)' }}>
              Don't have an account?{' '}
              <Link to="/signup" style={{ color: 'var(--gold)', fontWeight: 600, textDecoration: 'none' }} data-testid="signup-link">
                Sign up
              </Link>
            </p>
          </form>
        </div>

        <div style={{ marginTop: '2rem', textAlign: 'center' }}>
          <Link to="/" style={{ color: 'var(--gray)', fontSize: '0.875rem', textDecoration: 'none' }}>
            ← Back to website
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
